import { render, staticRenderFns } from "./UsagePatientsLineChart.vue?vue&type=template&id=7133738a"
import script from "./UsagePatientsLineChart.vue?vue&type=script&lang=js"
export * from "./UsagePatientsLineChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports